export default "__VITE_ASSET__nvN7EZCs__"